import axios from '../http.js'

//获得模板文件图片
function getTemplateImg(data) {
  return axios.baseAxios({
    url: '/backstage/authTemplate/getTemplateImg',
    method: 'get',
    params: data
  })
}
//获得模板文件图片
function queryAuthTemplatePage(data) {
  return axios.baseAxios({
    url: '/backstage/authTemplate/queryAuthTemplatePage',
    method: 'post',
    data: data
  })
}


export default {
  getTemplateImg,
  queryAuthTemplatePage,
}


// WEBPACK FOOTER //
// ./src/api/modules/accessCard.js